const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "VESSEL_TYPES_RETRIEVED":
            return action.vesselTypes;

        default:
            return state;
    }
}
